import { inject, Pipe, PipeTransform } from '@angular/core';
import { GcTableColumn, GcTableDataSource } from '@ip-only/front-end-library';
import { SharepointExportResponse } from '../entities/sharepoint-export-entities';
import { SharepointExportTableService } from '../service/sharepoint-export-table.service';

@Pipe({
  name: 'tableRowsSharepointExport',
})
export class TableRowsSharepointExportPipe implements PipeTransform {
  private readonly tableService = inject(SharepointExportTableService);

  transform(
    data: SharepointExportResponse | null | undefined,
  ): GcTableDataSource<GcTableColumn[]>[] {
    if (!data) return [];
    return this.tableService.getTableRowData(data);
  }
}
